import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'react-toastify';
import NotificationDropdown from '../../components/Notifications/NotificationDropdown';
import './TopHeader.css';

const TopHeader = ({ onMenuClick }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  const handleLogout = async () => {
    try {
      await logout();
      toast.success('Logged out successfully');
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
      toast.error('Failed to logout');
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      // Implement search functionality
      // console.log('Searching for:', searchQuery);
      toast.info('Search functionality coming soon!');
    }
  };

  const roleLabel = {
    admin: 'Admin', super_admin: 'Super Admin', subadmin: 'Sub Admin',
    employer: 'Employer', candidate: 'Candidate', consultant: 'Consultant'
  };

  const quickAction = user?.role === 'employer'
    ? { label: 'Post Job', icon: 'add_circle', path: '/employer/post-job' }
    : user?.role === 'candidate'
      ? { label: 'Browse Jobs', icon: 'search', path: '/jobs' }
      : null;

  return (
    <header className="top-header">
      <div className="header-left">
        <button className="header-hamburger" onClick={onMenuClick}>
          <span className="material-symbols-outlined">menu</span>
        </button>
        {/* {quickAction && (
          <Link to={quickAction.path} className="header-quick-btn">
            <span className="material-symbols-outlined">{quickAction.icon}</span>
            {quickAction.label}
          </Link>
        )} */}
      </div>

      <div className="header-right">
        {/* Notifications */}
        <NotificationDropdown />

        {/* User Menu */}
        <div className="header-user-wrap">
          <button
            className="header-user-btn"
            onClick={() => setShowUserMenu(!showUserMenu)}
          >
            <div className="header-avatar">{user?.name?.charAt(0).toUpperCase()}</div>
            <div className="header-user-info">
              <span className="header-user-name">{user?.name}</span>
              <span className="header-user-role">{roleLabel[user?.role] || user?.role}</span>
            </div>
            <span className="material-symbols-outlined header-chevron">expand_more</span>
          </button>

          {showUserMenu && (
            <div className="header-dropdown user-dropdown">
              <div className="hd-user-info">
                <div className="hd-avatar-lg">{user?.name?.charAt(0).toUpperCase()}</div>
                <div>
                  <div className="hd-user-name">{user?.name}</div>
                  <div className="hd-user-email">{user?.email}</div>
                  <span className="hd-role-badge">{roleLabel[user?.role] || user?.role}</span>
                </div>
              </div>
              <div className="hd-divider"></div>
              <Link className="hd-menu-item" to={`/${user?.role === 'employer' ? 'employer' : user?.role}/profile`} onClick={() => setShowUserMenu(false)}>
                <span className="material-symbols-outlined">person</span>My Profile
              </Link>
              <div className="hd-divider"></div>
              <button className="hd-logout-btn" onClick={handleLogout}>
                <span className="material-symbols-outlined">logout</span>Sign Out
              </button>
            </div>
          )}
        </div>
      </div>

      {showUserMenu && (
        <div className="dropdown-overlay" onClick={() => setShowUserMenu(false)} />
      )}
    </header>
  );
};

export default TopHeader;
